export type KeywordEntry = {
  keyword: string;
  monthlySearches: number;
  trend: string;
  competition: "bassa" | "media" | "alta";
  intent: "informational" | "navigational" | "mixed";
};

export const primaryKeyword = "wordle italiano";

export const keywordEntries: KeywordEntry[] = [
  {
    keyword: "wordle italiano",
    monthlySearches: 90500,
    trend: "+22% YoY",
    competition: "bassa",
    intent: "informational"
  },
  {
    keyword: "wordle italia",
    monthlySearches: 90500,
    trend: "+22% YoY",
    competition: "bassa",
    intent: "mixed"
  },
  {
    keyword: "wordle in italiano",
    monthlySearches: 2900,
    trend: "+24% YoY",
    competition: "bassa",
    intent: "informational"
  },
  {
    keyword: "wordle italiano verba",
    monthlySearches: 320,
    trend: "+50% YoY",
    competition: "bassa",
    intent: "mixed"
  },
  {
    keyword: "wordle italiano parole",
    monthlySearches: 140,
    trend: "+50% YoY",
    competition: "bassa",
    intent: "informational"
  },
  {
    keyword: "italiano wordle",
    monthlySearches: 90,
    trend: "+56% YoY",
    competition: "bassa",
    intent: "mixed"
  },
  {
    keyword: "wordle italiano unlimited",
    monthlySearches: 70,
    trend: "+125% YoY",
    competition: "bassa",
    intent: "informational"
  },
  {
    keyword: "wordle italiano senza limiti",
    monthlySearches: 50,
    trend: "stabile",
    competition: "media",
    intent: "informational"
  },
  {
    keyword: "wordle online italiano",
    monthlySearches: 10,
    trend: "stabile",
    competition: "bassa",
    intent: "informational"
  }
];

export const seoContentPlan = {
  title: "Wordle Italiano - Gioca Online Gratis in Italiano",
  description:
    "Gioca a Wordle Italiano online gratis: indovina la parola italiana del giorno, prova la modalita senza limiti e migliora la tua strategia con suggerimenti per parole italiane.",
  h1: "Wordle Italiano",
  h2: [
    "Gioca a Wordle in italiano",
    "Strategia per parole italiane",
    "Domande frequenti su Wordle Italiano"
  ],
  h3: [
    "Parola del giorno",
    "Wordle italiano senza limiti",
    "Parole iniziali consigliate"
  ],
  internalLinks: [
    { anchor: "Wordle Italiano", href: "/" },
    { anchor: "wordle in italiano senza limiti", href: "/#modalita-libera" },
    { anchor: "parole Wordle italiano", href: "/#strategie" },
    { anchor: "FAQ Wordle Italiano", href: "/#faq" }
  ],
  densityTargets: [
    { keyword: "wordle italiano", target: "1.2% - 1.8%" },
    { keyword: "wordle in italiano", target: "0.4% - 0.8%" },
    { keyword: "wordle italiano senza limiti", target: "0.2% - 0.5%" },
    { keyword: "parole wordle italiano", target: "0.2% - 0.5%" }
  ]
};
